<div class="page-width page__inner-wrap">
  <main id="main-content" class="main" role="main">
    <h1 class="page-title">Receipt</h1>
    <div class="receipt">
      <div class="data-item">
        <div class="data-item__label label">Practitioner Name</div>
        <div class="data-item__value">{{purchaseDetail?.practitionerName && purchaseDetail?.practitionerName !== '' ? purchaseDetail?.practitionerName : 'Not Available'}}</div>
      </div>
      <div class="data-item">
        <div class="data-item__label label">Payment Date</div>
        <div class="data-item__value">{{purchaseDetail?.transactionDate ? (purchaseDetail?.transactionDate | amDateFormat: 'LL') :  'no date'}}</div>
      </div>
      <div class="data-item">
        <div class="data-item__label label">Payment Method</div>
        <div class="data-item__value">{{paymentMethodLabel}}</div>
      </div>
      <p>Thank you for your purchase. We have received payment for the following:</p>
      <div class="cart">
        <div class="cart__items">
          <div class="cart-item" *ngFor="let item of purchaseDetail?.details">
            <div class="cart-item__product-wrap">
              <h3 class="cart-item__product-name">{{item.description}}</h3>
            </div>
            <div class="cart-item-data">
              <span class="cart-item-data__label">Unit Price:</span>
              <span class="cart-item-data__value">${{item?.cost | number : '1.2-2'}}</span>
            </div>
            <div class="cart-item-data">
              <span class="cart-item-data__label">Qty:</span>
              <span class="cart-item-data__value">{{item?.quantity}}</span>
            </div>
            <div class="cart-item-data">
              <span class="cart-item-data__label">Total Price:</span>
              <span class="cart-item-data__value">${{(item.cost || 0) * (item.quantity || 0) | number : '1.2-2'}}</span>
            </div>
          </div>
        </div>
        <div class="cart-totals">
          <div class="cart__totals-line cart-totals-line--total">
            Total: <span class="cart-totals-line__value">${{purchaseDetail?.totalAmount | number : '1.2-2'}}</span>
          </div>
        </div>
      </div>
      <div>		
          <div><span class="sg-image"><img src="/assets/images/nbrc-logo.jpg" /></span>        
            <div style="font-family: Corbel, sans-serif; font-size: 11pt; color: rgb(31, 78, 121);"><span>913.895.4900</span><br />
            <span>fax: 913.712.9283</span><br />
            <a>nbrc-info@nbrc.org</a><br />
            <span style="color:#642F6C"><b>NBRC.org</b></span><br />
            <br />
            <span style="font-size:11.0pt;font-family:corbel; color:#642F6C;"><b>EXCELLENCE <span style="font-size:11.0pt;font-family:corbel; color:#F1B434;">defines us.</span></b></span>
            </div>
          </div>
      </div>      
    </div>
    <div class="cart__actions">
      <button class="button button--tertiary " style="margin-right:0.25rem" (click)="emailPurchaseDetail()">
          <i class="button__icon icon icon--print"></i>
          <span class="button__text">Email Receipt</span>
      </button>    
      <button class="button button--tertiary " (click)="printPurchaseDetail()">
        <i class="button__icon icon icon--print"></i>
        <span class="button__text">Print Receipt</span>
      </button>
    </div>
  </main>
</div>

